import { combineReducers } from 'redux';
import { filterReducer } from '../../search/reducers/FilterReducer';
import { searchReducer } from '../../search/reducers/SearchReducer';
import { singleContentTypeReducer } from '../../search/reducers/SingleContentTypeReducer';
import { AppState } from '../state/AppState';
import { metricsDataReducer } from '../../search/reducers/MetricsDataReducer';

export const appReducer = combineReducers<AppState>({
  search: searchReducer,
  singleContentType: singleContentTypeReducer,
  filters: filterReducer,
  metricsData: metricsDataReducer,
});
